export default __webpack_public_path__ + "static/media/donacion_recurrente.7c9fec88.png";